/*
 *  ************************************************************************
 *  *  © [2015 - 2024] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import "./head-block.m.css";

export const HeadBlock = ({ group = {}, subscriptionConfig = {}, mode, isLoginless = false }) => {
  const { image_url: imageUrl = "", name } = group;
  const { pageTitle = "", pageDescription = "" } = subscriptionConfig;
  const emptyString = "<p><br></p>";
  const titleToUse = isLoginless
    ? (!pageTitle || pageTitle === emptyString ? "Upgrade to Premium" : pageTitle)
    : (pageTitle === emptyString ? "" : pageTitle);

  const updatedPageDescription = isLoginless ? "" : (pageDescription === emptyString ? "" : pageDescription);
  const displayPageDetails = titleToUse || updatedPageDescription;
  const style = isLoginless
    ? "align-left"
    : imageUrl && displayPageDetails
    ? "space"
    : "align-center";
  if (displayPageDetails || (imageUrl && !isLoginless)) {
    return (
      <div styleName={`wrapper ${style} ${mode} ${isLoginless ? "is-loginless" : ""}`}>
        {displayPageDetails && (
          <div>
            {titleToUse && (<h1 styleName="page-title" data-test-id="page-title" dangerouslySetInnerHTML={{ __html: titleToUse }} />)}
            {!isLoginless && updatedPageDescription && (
              <div styleName="page-description" data-test-id="page-description" dangerouslySetInnerHTML={{ __html: pageDescription }} />
            )}
          </div>
        )}
        {imageUrl && !isLoginless && (
          <div styleName="group-image" data-test-id="group-image">
            <img src={imageUrl} alt={name} />
          </div>
        )}
      </div>
    );
  }
  return null;
};
